var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input__container",style:({ width: 200 + 'px' })},[_c('span',{staticClass:"input__label"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('masked-input',{staticClass:"input__value",attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"type":_vm.type,"mask":_vm.mask},on:{"input":function($event){return _vm.change($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }